const ClickHelper = {

  isShiftPressed: (e) => {
    return e.shiftKey;
  },

  isMetaPressed: (e) => {
    return e.metaKey;
  }

}

export default ClickHelper;